import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { CommerceService } from './commerce.service';

export const Ng1CommerceModule = angular
    .module('control-room.shared.services.commerce', [])
    .factory('crCommerceService',downgradeInjectable(CommerceService));
